export default __webpack_public_path__ + "static/media/beep.37210172.mp3";